import { List } from 'immutable'
import { getAxios } from './projectAxios'
import { IS_DEV } from '../constants/ssr'

const axios = getAxios()
const errorsHash = {}

export const logError = (name, error, meta = {}) => {
  if (!IS_DEV) {
  }
  if (!error) {
    return false
  }
  let errorText = String(error)
  if (
    errorText.includes('removeChild') ||
    errorText.includes('ChunkLoadError') ||
    errorText.includes('Loading CSS chunk') ||
    errorText.includes('insertBefore')
  ) {
    return false
  }
  if (!errorsHash[errorText]) {
    axios
      .post('/webprojects/client-log-error', {
        name,
        error: errorText,
        meta,
      })
      .then(({ status }) => {
        console.log('logError = ', status)
      })
      .catch((error) => {
        console.log('logError error ', error)
      })
  }
}

export const getActivePageField = (state, key = 'uid') => {
  try {
    let pages = state.getIn(['project', 'Pages'], List())
    const page = state.get('page')
    let activePage = pages.find((val) => val.get('_id') === page)
    if (activePage) {
      return activePage.get('key')
    }
  } catch (error) {
    console.error(error)
  }
  return null
}
